let activeSearch = function() {
	this.searchValid = !this.searchValid;
};
export default activeSearch;
